import { render, staticRenderFns } from "./newsArchive.vue?vue&type=template&id=30dbaf92"
import script from "./newsArchive.vue?vue&type=script&lang=js"
export * from "./newsArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports